
import { defineComponent } from 'vue';

import CitationsHandle from './blocks/citations-handle.vue';
import CitationsHead from './blocks/citations-head.vue';

import { citationsComposition } from '../services';
import { panelComposition } from '@/core/modules/panel/services';
import { overlayComposition } from '@/core/modules/overlay/services';

// Render Function 
// TODO: Remove to Config
import citationsConfig from '../config/citations.config';
import CitationsList from '../components/renderer/CitationsList.vue';
import CitationsUnordered from '../components/renderer/CitationsUnordered.vue';
import CitationsAbbreviations from '../components/renderer/CitationsAbbreviations.vue';

export default defineComponent({
	components: {
		CitationsHandle,
		CitationsHead,
		CitationsList,
		CitationsUnordered,
		CitationsAbbreviations
	},
	props: {
		citations: {
			type: Array,
			required: true
		},
		hideHandle: {
			type: Boolean,
			default: false
		}
	},
	setup (props) {
		const { overlay } = overlayComposition();

		// Function to render component
		function rendererFunctionOverlay () {
			return citationsConfigFn()?.renderer;
		}

		// Function to get citations config
		function citationsConfigFn () {
			return citationsConfig.find((_: any) => _.type === overlay.value);
		}

		return { ...citationsComposition(props), ...panelComposition(), ...overlayComposition(), rendererFunctionOverlay };
	}
})
